<template>
<div>
    <b-navbar class="auction-data bg-grey top" :sticky="true" style="top: 100px; height: 90px">
	</b-navbar>
	<div class="text-grey">
		<b-container id="specifications" fluid>
			<b-row>
				<b-col md="12" xl="8" lg="7">
                    <vue-content-loading :speed="2" :width="90" :height="50">
                        <rect x="2" y="2" rx="0"  width="90" height="50" />
                    </vue-content-loading>
				</b-col>
				<b-col>
					<b-row class="mt-4">
						<b-col cols="8">
                            <vue-content-loading :speed="2" :width="100" :height="10">
                                <rect x="0" y="0" rx="0"  width="20" height="50" />
                                <rect x="22" y="0" rx="0"  width="50" height="50" />
                            </vue-content-loading><br />
                        </b-col>
					</b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <vue-content-loading :speed="2" :width="10" :height="1">
                                <rect x="0" y="0" rx="0"  width="10" height="1" />
                            </vue-content-loading><br />
                        </b-col>
                    </b-row>
					<div class="lead mt-4">
                        <vue-content-loading :speed="2" :width="100" :height="20">
                            <rect x="0" y="0" rx="0"  width="50" height="9" />
                            <rect x="0" y="10" rx="0"  width="50" height="9" />
                        </vue-content-loading>
                    </div>
					<b-table-simple borderless class="mt-2">
						<b-tr>
							<b-td class="p-0">
                                <vue-content-loading :speed="2" :width="100" :height="20">
                                    <rect x="0" y="0" rx="0"  width="50" height="9" />
                                </vue-content-loading>
                            </b-td>
							<b-td class="p-0">
                                <vue-content-loading :speed="2" :width="100" :height="20">
                                    <rect x="0" y="0" rx="0"  width="50" height="9" />
                                </vue-content-loading>
                            </b-td>
						</b-tr>
						<b-tr>
							<b-td class="p-0">
                                <vue-content-loading :speed="2" :width="100" :height="20">
                                    <rect x="0" y="0" rx="0"  width="50" height="9" />
                                </vue-content-loading>
                            </b-td>
							<b-td class="p-0">
                                <vue-content-loading :speed="2" :width="100" :height="20">
                                    <rect x="0" y="0" rx="0"  width="50" height="9" />
                                </vue-content-loading>
                            </b-td>
						</b-tr>
					</b-table-simple>
					<b-row>
						<b-col class="">
                                <vue-content-loading :speed="2" :width="100" :height="5">
                                    <rect x="0" y="0" rx="0"  width="10" height="5" />
                                </vue-content-loading>
                                <vue-content-loading :speed="2" :width="100" :height="20">
                                    <rect x="0" y="5" rx="0"  width="50" height="9" />
                                </vue-content-loading>
						</b-col>
					</b-row>
                    <vue-content-loading :speed="2" :width="100" :height="20">
                        <rect x="0" y="0" rx="0"  width="80" height="15" />
                    </vue-content-loading>
				</b-col>
			</b-row>
		</b-container>
        <b-container class="mt-5" fluid>
            <vue-content-loading :speed="2" :width="100" :height="20">
                <rect x="2" y="1" rx="0"  width="95" height="20" />
            </vue-content-loading>
        </b-container>
	</div>
</div>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
  export default {
	name: 'CarLoading',
	components: {
		VueContentLoading
    },
    data(){
        return {
            car: {}
        }
    },
	mounted() {	

    },
  }
</script>
